// Mock data and functions for frontend-only functionality

export const mockProjects = [
  {
    id: 1,
    title: "Interior Living Room Painting – Los Angeles",
    image: "https://images.unsplash.com/photo-1615873968403-89e068629265?w=800&q=80",
    description: "Complete interior transformation"
  },
  {
    id: 2,
    title: "Exterior Home Painting – Los Angeles",
    image: "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=800&q=80",
    description: "Professional exterior painting"
  },
  {
    id: 3,
    title: "Cabinet Refinishing – Los Angeles",
    image: "https://images.unsplash.com/photo-1556912173-46c336c7fd55?w=800&q=80",
    description: "Kitchen cabinet restoration"
  },
  {
    id: 4,
    title: "Bedroom Interior Painting – Los Angeles",
    image: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=800&q=80",
    description: "Cozy bedroom painting"
  },
  {
    id: 5,
    title: "Exterior House Refresh – Los Angeles",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80",
    description: "Complete exterior makeover"
  },
  {
    id: 6,
    title: "Office Interior Painting – Los Angeles",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80",
    description: "Professional office space painting"
  }
];

export const services = [
  {
    id: 1,
    title: "Interior Painting",
    description: "Transform your living spaces with professional interior painting services. Quality finishes for walls, ceilings, and more.",
    icon: "Home"
  },
  {
    id: 2,
    title: "Exterior Painting",
    description: "Protect and beautify your home's exterior with weather-resistant paints and expert application techniques.",
    icon: "Building"
  },
  {
    id: 3,
    title: "Cabinet Painting",
    description: "Refresh your kitchen or bathroom with cabinet refinishing. A cost-effective way to update your space.",
    icon: "Brush"
  },
  {
    id: 4,
    title: "Trim & Detail Work",
    description: "Precision painting for trim, molding, doors, and architectural details that make your home stand out.",
    icon: "Sparkles"
  },
  {
    id: 5,
    title: "Wall Preparation & Repairs",
    description: "Professional surface preparation including patching, sanding, and priming for a flawless finish.",
    icon: "Wrench"
  },
  {
    id: 6,
    title: "Color Consultation",
    description: "Expert guidance on color selection to match your style and enhance your home's appeal.",
    icon: "Palette"
  }
];

export const whyChooseUs = [
  {
    title: "Locally Owned & Operated",
    description: "Serving Los Angeles homeowners with personalized service and local expertise.",
    icon: "MapPin"
  },
  {
    title: "Transparent Written Pricing",
    description: "Detailed written estimates before work begins. No hidden fees or surprises.",
    icon: "FileText"
  },
  {
    title: "Experienced Crew",
    description: "Professional painters with years of experience delivering quality results.",
    icon: "Users"
  },
  {
    title: "Quality Materials",
    description: "We use premium paints and materials for long-lasting, beautiful finishes.",
    icon: "Award"
  },
  {
    title: "Dedicated Customer Support",
    description: "Clear communication throughout your project from consultation to completion.",
    icon: "MessageSquare"
  },
  {
    title: "Clean & Professional",
    description: "Respect for your home with thorough cleanup and attention to detail.",
    icon: "Shield"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Schedule Consultation",
    description: "Contact us to discuss your painting project and schedule a convenient time for an in-home consultation.",
    icon: "Calendar"
  },
  {
    step: 2,
    title: "Receive Written Estimate",
    description: "Get a detailed, transparent written estimate with no hidden costs. We'll explain the scope and timeline.",
    icon: "FileCheck"
  },
  {
    step: 3,
    title: "Professional Painting & Cleanup",
    description: "Our experienced crew completes your project with quality workmanship and thorough cleanup.",
    icon: "CheckCircle"
  }
];

// Mock form submission
export const mockSubmitEstimate = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Form submitted:', formData);
      resolve({
        success: true,
        message: 'Thank you! We will contact you within 24 hours.'
      });
    }, 1000);
  });
};
